<template>
  <div>
    <v-data-table
      :loading="loading"
      :items="payouts"
      :headers="headers"
      disable-pagination
      hide-default-footer
      mobile-breakpoint="0"
    >
      <template #[`item.paidDate`]="{ item }">
        <template v-if="!item.paidDate"> Pending </template>
        <template v-else>
          {{ item.paidDate | normalDate }}
        </template>
      </template>
      <template #[`item.total`]="{ item }">
        {{ item.total | currency }}
      </template>
      <template #[`item.actions`]="{ item }">
        <UserPayButton
          :sub-total="item.paidDate ? 0 : item.total"
          :user-id="user.id"
        />
      </template>
    </v-data-table>
    <UserPayDrawer />
  </div>
</template>

<script>
import UserPayButton from '@/components/users/pay/Button';
import UserPayDrawer from '@/components/users/pay/Drawer';
import { mapGetters } from 'vuex';
export default {
  name: 'UserPayouts',
  components: { UserPayButton, UserPayDrawer },
  data: () => {
    return {
      headers: [
        { text: 'Date', value: 'paidDate' },
        { text: 'Customer', value: 'customerProjectCount' },
        { text: 'Total', value: 'total' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      user: 'users/user',
      payouts: 'users/payouts'
    })
  },
  mounted() {}
};
</script>
